import { connect } from 'react-redux';
import VerifyWithdrawalComponent from '../components/VerifyWithdrawalComponent';
import action from '../redux/actions/transactions';

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  onVerifyWithdrawal: (params) => {
    dispatch(action.verifyWithdrawal(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyWithdrawalComponent);
